import React from 'react';

import { Alert, Anchor, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export function InternationalPhoneNumberInfoAlert() {
  const { t } = useTranslation();
  return (
    <Alert color="blue" icon={<IconInfoCircle />}>
      <Text size="sm" weight={500}>
        {t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.ALERT.TITLE')}
      </Text>
      <Text size="xs">
        {t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.ALERT.DESCRIPTION')}{' '}
        <Anchor href="https://help.twilio.com/articles/223135247" target="_blank" rel="noopener noreferrer" inherit>
          {t('SMART_ASSISTANT.TELEPHONY_SECTION.PURCHASE_MODAL.ALERT.LEARN_MORE')}
        </Anchor>
      </Text>
    </Alert>
  );
}
